export default "__VITE_ASSET__DH90Tavo__"